const initCounter = (start, finish, data) => {
   const counters = document.querySelectorAll("[data-counter]"),
    countersPrograms = document.querySelectorAll("[data-counter-program]");   
 
   function decreaseQuantity(start, finish, total, final, rate) {
     let startDate = start, // Начальное дата
       finishDate = finish, // Конечная дата
       totalMembers = total, // Начальное число мест
       finalNunber = final, // Конечное число мест
       ratio = rate, // На какое количество уменьшаем
       shift,
       stepDay,
       number,
       formatNumber;
 
     // Возвращает пробелы в числах
     function format(value) {
       return new Intl.NumberFormat().format(value);
     }
 
     // Склонение окончания в тексте
     function declination(number, txt) {
       var cases = [2, 0, 1, 1, 1, 2];
       return txt[
         number % 100 > 4 && number % 100 < 20
           ? 2
           : cases[number % 10 < 5 ? number % 10 : 5]
       ];
     }
 
     // Количество дней прошедших с даты старта счетчика
     stepDay = Math.floor((Date.now() - startDate) / 864e5);
 
     if (stepDay <= 0) {
       shift = 0;
     } else {
       shift = ratio * stepDay;
     }
 
     if (stepDay >= (finishDate - startDate) / 864e5) {
       number = finalNunber;
     } else {
       number = totalMembers - shift;
     }
 
     formatNumber =
       format(number) + " " + declination(number, ["место", "места", "мест"]);
 
     return formatNumber;
   }
 
   counters.length &&
     counters.forEach(
       (counter) =>
         (counter.innerHTML = decreaseQuantity(
           start,
           finish,
           data.main.total,
           data.main.final,
           data.main.rate
         ))
     );
 
   countersPrograms.length &&
     countersPrograms.forEach(
       (counter) =>
         (counter.innerHTML = decreaseQuantity(
           start,
           finish,
           data.program.total,
           data.program.final,
           data.program.rate
         ))
     );
 };
 
 export default initCounter;
 